import { jsxs, jsx } from 'react/jsx-runtime';
import { matchPath } from 'react-router';
import { useModalContext, Modal, Button, LinkButton } from '@sketch/components';
import { routes, LaunchSketchAlert } from '@sketch/modules-common';

const PraticeModal = ({ title, url, hideModal, }) => {
    var _a, _b;
    const { showModal } = useModalContext();
    const path = (_a = new URL(url)) === null || _a === void 0 ? void 0 : _a.pathname;
    const share = matchPath(path, {
        path: routes.SHARE_VIEW.template(),
        exact: true,
    });
    const shareId = (_b = share === null || share === void 0 ? void 0 : share.params.shareID) !== null && _b !== void 0 ? _b : ''; // Empty string will at least open the Mac App
    const handleCancel = () => {
        hideModal();
    };
    return (jsxs(Modal, Object.assign({ onCancel: hideModal, title: `Pratice: ${title}` }, { children: [jsx(Modal.Body, { children: "You can edit this step-by-step guide directly in Sketch, or view it in your browser." }), jsxs(Modal.Footer, Object.assign({ leftContent: jsx(Button, Object.assign({ onClick: handleCancel }, { children: "Close" })) }, { children: [jsx(LinkButton, Object.assign({ href: url, external: true }, { children: "View in Browser" })), jsx(Button, Object.assign({ variant: "primary", onClick: () => showModal(LaunchSketchAlert, {
                            shareId,
                            action: 'openInSketch',
                        }) }, { children: "Edit in Sketch" }))] }))] })));
};

export { PraticeModal as default };
